import Box from '@mui/material/Box';

// project imports
import Search from './Search';
import Profile from './Profile';
import Notification from './Notification';
import ModeSelector from './ModeSelector';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  return (
    <>
      {/* Lado esquerdo: pesquisa + seletor Produção/Sandbox; ocupa o espaço livre e empurra o resto para a direita */}
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 1.5, ml: 1, mr: { xs: 1, md: 0 } }}>
        <Search />
        <ModeSelector />
      </Box>
      <Notification />
      <Profile />
    </>
  );
}
